<label class="switch" [ngClass]="{'checked': value}" #check>
  <i class="fa fa-check icon-ok" aria-hidden="true"></i>
  <i class="fa fa-times icon-remove" aria-hidden="true"></i>
  <input type="checkbox" (click)="changeState(check)">
</label>
